<h2 mat-dialog-title>{{ isEditMode ? 'Edit Campaign' : 'Create Campaign' }}</h2>
<mat-dialog-content>
  <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">

    <div class="form-field">
        <label for="name">Name</label>
        <input  type="text" id="name" formControlName="name">
      </div>

    <!-- System Dropdown -->
    <div class="form-field">
      <div class="label-row">
        <label for="systems">System:</label>
        <span class="label-actions">
          {{ subscriptionForm.get('systems').value?.length || 0 }} of {{ systems.length }} selected
          <button mat-button type="button" color="primary" (click)="selectAllSystems()">Select all</button>
          <button mat-button type="button" (click)="clearSystems()">Clear</button>
        </span>
      </div>
      <input
      matInput
      type="text"
      placeholder="Search system"
      (keyup)="filterSystems($event.target.value)" />
      <mat-select #mySelect id="systems" formControlName="systems" multiple>
        <mat-option  *ngFor="let system of filteredSystems" [value]="system.systemId" >{{ system.systemName }}</mat-option>
      </mat-select>
    </div>

    <p class="hint">Choose categories, products, or both. The discount applies to every product in the chosen categories and to each chosen product.</p>

    <!-- Categories Multi-Select Dropdown -->
    <div class="form-field">
      <label for="categories">Categories:</label>
      <mat-select id="categories" formControlName="categories" multiple>
        <mat-option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</mat-option>
      </mat-select>
    </div>

    <!-- Products Multi-Select Dropdown -->
    <div class="form-field">
      <label for="products">Products:</label>
      <input
        matInput
        type="text"
        placeholder="Search product name or number"
        (keyup)="filterProducts($event.target.value)" />
      <mat-select #productSelect id="products" formControlName="products" multiple>
        <mat-option *ngFor="let product of filteredProducts" [value]="product.id">
          {{ product.name }}<span *ngIf="product.price" class="muted"> · {{ product.price }} kr</span>
        </mat-option>
      </mat-select>
      <div class="chips" *ngIf="selectedProductNames.length">
        <span class="chip" *ngFor="let name of selectedProductNames">{{ name }}</span>
      </div>
    </div>

    <div class="form-error" *ngIf="subscriptionForm.hasError('noTarget') && (subscriptionForm.get('categories').touched || subscriptionForm.get('products').touched)">
      Choose at least one category or product.
    </div>

    <!-- Start Time -->
    <div class="form-field">
      <label for="startTime">Start Time:</label>
      <input matInput type="time" id="startTime" formControlName="startTime">
    </div>

    <!-- End Time -->
    <div class="form-field">
      <label for="endTime">End Time:</label>
      <input matInput type="time" id="endTime" formControlName="endTime">
    </div>

    <!-- Percentage -->
    <div class="form-field">
      <label for="percentage">Percentage:</label>
      <input matInput type="number" id="percentage" formControlName="percentage">
    </div>

    <!-- Week Days -->
    <div class="form-field">
      <div class="label-row">
        <label>{{ isEditMode ? 'Week day:' : 'Week days:' }}</label>
        <span class="label-actions" *ngIf="!isEditMode">
          <button mat-button type="button" color="primary" (click)="selectAllDays()">Every day</button>
        </span>
      </div>
      <div class="checkbox-group">
        <mat-select *ngIf="isEditMode" id="selectedDays" formControlName="selectedDays">
            <mat-option *ngFor="let day of weekDays"  [value]="day.index"> {{ day.name }}</mat-option>
          </mat-select>
        <mat-select *ngIf="!isEditMode" id="selectedDays" formControlName="selectedDays" multiple>
            <mat-option *ngFor="let day of weekDays"  [value]="day.index"> {{ day.name }}</mat-option>
          </mat-select>
      </div>
      <p class="hint" *ngIf="!isEditMode">One campaign is created per chosen day, so each day can be edited or removed on its own later.</p>
    </div>


    <div class="form-field">
      <label>Active</label>
      <div class="checkbox-group">
        <mat-select id="active" formControlName="active">
            <mat-option   value="true"> Yes</mat-option>
            <mat-option   value="false"> No</mat-option>
          </mat-select>

      </div>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!subscriptionForm.valid"  (click)="onSubmit()">
    {{ isEditMode ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>
